var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSection2IconSolution = function SvgSection2IconSolution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.289,
    fill: "#F9F6FF",
    stroke: "#6400FF",
    strokeWidth: 1.422
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9 16.5 6 4L21.428 10",
    stroke: "#6400FF",
    strokeWidth: 3
  })));
};
export default SvgSection2IconSolution;